// extracted by mini-css-extract-plugin
export default {"billingDetails":"billingDetails_billingDetails__BI24S","billingDetails__label":"billingDetails_billingDetails__label__nbHtO","label":"billingDetails_label__7HAkq"};